import { render, staticRenderFns } from "./AssessmentRoute.vue?vue&type=template&id=264aaa01"
import script from "./AssessmentRoute.vue?vue&type=script&lang=js"
export * from "./AssessmentRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports